import { Col, Flex, Row } from "antd";
import { useTranslation } from "react-i18next";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import React, { useEffect, useState } from "react";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import clsx from "clsx";
import { Widget } from "../../../../Atomics/Widget";
import { energyHistoric } from "../../dummyData";
import logger from "../../../../../../server/server";
import { months } from "../../../../../../utils/dummydata";
import { useAuthContext } from "../../../../../../contexts/AuthContext";

// Componente principal que exibe o histórico de consumo energético de um edifício
export const BuildingEnergeticConsumptionHistoric = ({
  building,
  currentFloor,
  ...props
}) => {
  // Definindo meses e anos para os dropdowns de seleção
  const years = [
    { value: 2022, label: "2022" },
    { value: 2023, label: "2023" },
    { value: 2024, label: "2024" },
  ];
  // Hook de tradução
  const { t } = useTranslation();
  const {user,tenant} = useAuthContext();
  useEffect(() => {
    logger.info("User: " + user?.Username + " entered BuildingEnergeticConsumptionHistoric successful! Tenant: " + tenant);
  }, []);
  // Definindo o mês e ano atuais
  const currentMonth = new Date().getMonth() + 1; // JavaScript getMonth() retorna o mês de 0 a 11, então adicionamos 1
  const [selectedMonth, setSelectedMonth] = useState(
    months(t).find((month) => month.value === currentMonth)?.value
  );
  const [selectedYear, setSelectedYear] = useState(2024);
  const [selectedDay, setSelectedDay] = useState();

  // Hook customizado para buscar dados do histórico de consumo energético
  // const {
  //   data: energeticConsumptionHistoricData,
  //   isLoading: energeticConsumptionHistoricIsLoading,
  //   refetch: refetchEnergeticConsumptionHistoric,
  //   isFetching,
  // } = useFetch(
  //   "/unified_temporary/energyConsumptionHistoric",
  //   "energeticConsumptionHistoric",
  //   {
  //     buildingId: building?.id,
  //     selectedMonth: selectedMonth,
  //     selectedYear: selectedYear,
  //     currentFloor: currentFloor,
  //   }
  // );

  // Refetch dos dados quando o mês ou ano selecionados mudam
  // useEffect(() => {
  //   refetchEnergeticConsumptionHistoric();
  // }, [selectedMonth, selectedYear]);

  return (
    <>
      {/* Conteúdo da página com layout e estrutura com Col e Rows */}
      <PageContent className={clsx("building_room_details", props?.className)}>
        {/* {!isFetching ? ( //check if the data is still fetching */}
        <Row gutter={[16, 16]}>
          {/* Define o layout de linhas com largura total */}
          <Col span={24} style={{ alignContent: "center" }}>
            <Row>
              <Col span={10}>
                <h3>
                  {building?.name} |{" "}
                  {t("Energetic Consumption").toLocaleUpperCase()}{" "}
                  {/* Changes the title to upperCase and translates it */}
                </h3>
              </Col>
              <Col span={6} offset={8} style={{ alignContent: "center" }}>
                <Row gutter={16}>
                  <Col span={12}>
                    <SelectAtomic
                      optionsData={months(t)}
                      handleOptionsChange={(value) => {
                        setSelectedMonth(value);
                      }}
                      defaultValue={selectedMonth}
                      fullWidth={true}
                    />
                  </Col>
                  <Col span={12}>
                    <SelectAtomic
                      optionsData={years}
                      handleOptionsChange={(value) => {
                        setSelectedYear(value);
                      }}
                      defaultValue={selectedYear}
                      fullWidth={true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          {/* Widgets com dados de consumo energético */}
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Widget
                      className="full-h"
                      data={{
                        background: "white", // Define o fundo como transparente
                        title: t("Average Energy Consumption"), // Título do Widget traduzido
                        icon: null, // Nenhum ícone definido
                        charts: [
                          {
                            chartType: "bigNumberChart",
                            chartId: "bigNumberChartOne",
                            height: "100px",
                            data: energyHistoric?.averageEnergyConsumption,
                          },
                        ],
                      }}
                    />
                  </Col>
                  <Col span={12}>
                    <Widget
                      data={{
                        background: "white",
                        title: t("Energy consumption per user"),
                        icon: null,
                        charts: [
                          {
                            chartType: "bigNumberChart",
                            chartId: "bigNumberChartOne",
                            height: "100px",
                            data: energyHistoric?.energyConsumptionPerUser,
                          },
                        ],
                      }}
                    />
                  </Col>
                  <Col span={24}>
                    <Widget
                      data={{
                        background: "white",
                        title: t("Peak of the month"),
                        icon: null,
                        charts: [
                          {
                            chartType: "multipleBigNumberChart",
                            chartId: "multipleBigNumberChart",
                            height: "100px",
                            data: energyHistoric?.peakOfTheMonth,
                          },
                        ],
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={16}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Evolution of floor energy consumption"),
                    icon: null,
                    charts: [
                      {
                        chartType: "mixedLineColumnChartApex",
                        chartId: "mixedLineColumnChartApexOne",
                        height: "300px",
                        data: energyHistoric?.evolutionOfFloorEnergyConsumption,
                      },
                    ],
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={16}>
              <Col span={8}>
                <Widget
                  data={{
                    background: "white",
                    title: t("Consumption per Hour"),
                    icon: null,
                    charts: [
                      {
                        chartType: "simpleDonutChartApex",
                        chartId: "donutChartOne",
                        height: "220px",
                        data: energyHistoric?.consumptionPerFloor,
                      },
                    ],
                  }}
                />
              </Col>
              <Col span={16}>
                <Widget
                  data={{
                    background: "white",
                    title: t(
                      "Evolution of floor energy consumption during the day"
                    ),
                    icon: null,
                    dropdowns: [
                      {
                        data: [
                          { value: 1, label: t("day") + " 1" },
                          { value: 2, label: t("day") + " 2" },
                          { value: 3, label: t("day") + " 3" },
                          { value: 4, label: t("day") + " 4" },
                          { value: 5, label: t("day") + " 5" },
                          { value: 6, label: t("day") + " 6" },
                          { value: 7, label: t("day") + " 7" },
                          { value: 8, label: t("day") + " 8" },
                          { value: 9, label: t("day") + " 9" },
                          { value: 10, label: t("day") + " 10" },
                          { value: 11, label: t("day") + " 11" },
                          { value: 12, label: t("day") + " 12" },
                          { value: 12, label: t("day") + " 13" },
                        ],
                        value: selectedDay,
                        functionChange: (value) => setSelectedDay(value),
                        width: "110%",
                      },
                    ],
                    charts: [
                      {
                        chartType: "mixedLineColumnChartApex",
                        chartId: "mixedLineColumnChartApexOne",
                        data: energyHistoric?.evolutionOfFloorEnergyConsumption,
                        height: "200px",
                      },
                    ],
                  }}
                />
              </Col>
            </Row>
          </Col>
          {/* </Col> */}
        </Row>
        {/* ) : (
            <Flex justify="center">
              <Spinner stroke="green" size="42px" />
            </Flex> //while data is fetching, a simple spinner will show up in the page
          )} */}
      </PageContent>
    </>
  );
};